module.exports = __webpack_public_path__ + "static/img/content12.343c26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/content12.png
// module id = s49e
// module chunks = 1 3